"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultUrlFilter = getDefaultUrlFilter;
exports.getDefaultUrlGroupFilter = getDefaultUrlGroupFilter;
exports.getDefaultBlankFilter = getDefaultBlankFilter;
exports.getDefaultShowFilter = getDefaultShowFilter;
exports.getDefaultHideFilter = getDefaultHideFilter;
exports.getInitialFilter = getInitialFilter;
exports.getNewFilterGroup = getNewFilterGroup;
exports.getAudienceFilters = getAudienceFilters;
exports.selectFilterGroups = selectFilterGroups;
exports.selectHideParentFilterGroup = selectHideParentFilterGroup;
exports.selectHideFilterGroups = selectHideFilterGroups;
exports.selectGroup = selectGroup;
exports.filterById = filterById;
exports.ommitId = ommitId;
exports.filterByGroup = filterByGroup;
exports.updateGroupValues = updateGroupValues;
exports.noShowValues = noShowValues;
exports.getFirstOperator = getFirstOperator;
exports.getFirstAndValue = getFirstAndValue;
exports.isURLType = isURLType;
exports.isFirstURL = isFirstURL;
exports.isFilterAll = isFilterAll;
exports.validateValues = validateValues;

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _FilterRecord = _interopRequireDefault(require("lead-flows-ui/constants/AudienceTargeting/FilterRecord"));

var _ValidationUtils = require("lead-flows-ui/utils/ValidationUtils");

var urlTypes = {
  URL: true,
  PAGE_VISITS: true,
  REFERRER: true
};
var urlOperators = {
  EQ: true,
  STR_STARTS_WITH: true
};

function isImmutable(obj) {
  return Boolean(obj && obj.toJS);
}

function getDefaultUrlFilter() {
  return new _FilterRecord.default({
    operator: 'ALL',
    type: 'URL',
    values: ''
  });
}

function getDefaultUrlGroupFilter() {
  return new _FilterRecord.default({
    operator: 'OR',
    type: 'BOOLEAN',
    values: new _immutable.List([getDefaultUrlFilter()])
  });
}

function getDefaultBlankFilter() {
  return new _FilterRecord.default({
    operator: 'OR',
    type: 'BOOLEAN',
    values: new _immutable.List([new _FilterRecord.default()])
  });
}

function getDefaultShowFilter() {
  return new _FilterRecord.default({
    type: 'BOOLEAN',
    operator: 'AND',
    values: new _immutable.List([getDefaultUrlGroupFilter()])
  });
}

function getDefaultHideFilter() {
  return new _FilterRecord.default({
    type: 'BOOLEAN',
    operator: 'NOT',
    values: new _immutable.List([new _FilterRecord.default({
      operator: 'AND',
      type: 'BOOLEAN',
      values: new _immutable.List([])
    })])
  });
}

function getInitialFilter() {
  var filterGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var showFilter = filterGroups.show || getDefaultShowFilter();
  var hideFilter = filterGroups.hide || getDefaultHideFilter();
  return new _FilterRecord.default({
    type: 'BOOLEAN',
    operator: 'AND',
    values: new _immutable.List([showFilter, hideFilter])
  });
}

function getNewFilterGroup() {
  var operator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'OR';
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'BOOLEAN';
  return new _FilterRecord.default({
    values: new _immutable.List([new _FilterRecord.default()]),
    operator: operator,
    type: type
  });
}

function getAudienceFilters(audience) {
  var filters = audience ? audience.filters : getInitialFilter();
  return (0, _immutable.fromJS)(filters);
}

function selectFilterGroups(filter) {
  var filterGroups = (0, _immutable.fromJS)(filter).get('values').find(function (i) {
    return i.get('operator') === 'AND';
  });
  return filterGroups;
}

function selectHideParentFilterGroup(filter) {
  return (0, _immutable.fromJS)(filter).get('values').find(function (i) {
    return i.get('operator') === 'NOT';
  });
}

function selectHideFilterGroups(filter) {
  var hideGroup = selectHideParentFilterGroup(filter);
  var filterGroups;

  if (hideGroup) {
    filterGroups = hideGroup.get('values').find(function (i) {
      return i.get('operator') === 'AND';
    });
  }

  return filterGroups;
}

function selectGroup(filter, rootGroup) {
  if (!filter) {
    return null;
  }

  switch (rootGroup) {
    case 'SHOW':
      return selectFilterGroups(filter);

    case 'HIDE':
      return selectHideFilterGroups(filter);

    default:
      return filter;
  }
}

function filterById(filters, id) {
  return (0, _defineProperty2.default)({}, id, filters[id]);
}

function ommitId(filter) {
  var id = filter.id,
      noId = (0, _objectWithoutProperties2.default)(filter, ["id"]);
  return {
    id: id,
    noId: noId
  };
}

function filterByGroup(filters, group) {
  return Object.keys(filters).map(function (i) {
    return (0, _extends3.default)({
      id: i
    }, filters[i]);
  }).filter(function (i) {
    return i.group === group;
  }).reduce(function (acc, i) {
    return (0, _extends3.default)({}, acc, (0, _defineProperty2.default)({}, ommitId(i).id, ommitId(i).noId));
  }, {});
}

function updateGroupValues(filter, rootGroup, group) {
  switch (rootGroup) {
    case 'SHOW':
      return filter.setIn(['values', 0, 'values'], group);

    case 'HIDE':
      return filter.setIn(['values', 1, 'values', 0, 'values'], group);

    default:
      return filter;
  }
}

function noShowValues(filter) {
  var immutableFilter = isImmutable(filter) ? filter : (0, _immutable.fromJS)(filter);
  var values = immutableFilter.getIn(['values', 0, 'values', 0, 'values']);
  return !Boolean(values);
}

function getFirstOperator(filter) {
  var immutableFilter = isImmutable(filter) ? filter : (0, _immutable.fromJS)(filter);
  return immutableFilter.getIn(['values', 0, 'values', 0, 'values', 0, 'operator']);
}

function getFirstAndValue(filter) {
  var immutableFilter = isImmutable(filter) ? filter : (0, _immutable.fromJS)(filter);
  var value = immutableFilter.getIn(['values', 0, 'values', 0, 'values', 0]);
  return value;
}

function isURLType(value) {
  return value ? value.get('type') === 'URL' : false;
}

function isFirstURL(filter) {
  var firstAndValue = filter && getFirstAndValue(filter);
  return isURLType(firstAndValue);
}

function isFilterAll(filter) {
  var operator = filter && getFirstOperator(filter);
  return operator === 'ALL';
}

function validateValues(vals) {
  if (!vals.map) {
    return true;
  }

  return vals.map(function (val) {
    return (0, _immutable.fromJS)(val);
  }).every(function (val) {
    if (!val.get) {
      return true;
    }

    var values = val.get('values');
    var type = val.get('type');
    var operator = val.get('operator');

    if (values) {
      if (Array.isArray(values)) {
        return Boolean(values.length);
      } else {
        if (urlTypes[type] && urlOperators[operator]) {
          return (0, _ValidationUtils.isValidDynoUrl)(values);
        } else if (type === 'QUERY_PARAM') {
          return Boolean(values.name) && Boolean(values.value);
        } else if (_immutable.List.isList(values)) {
          return validateValues(values);
        } else {
          return Boolean(values);
        }
      }
    } else if (operator === 'ALL') {
      return true;
    } else {
      return false;
    }
  });
}